export const propertyDamageType = {
  POST_PROPERTY_DAMAGE_PENDING:
    "[POST_PROPERTY_DAMAGE_PENDING][REQUEST] Try To create Property Damage",
  POST_PROPERTY_DAMAGE_FAILURE:
    "[POST_PROPERTY_DAMAGE_FAILURE][RESPONSE] Property Damage Failed",
  POST_PROPERTY_DAMAGE_SUCCESS:
    "[POST_PROPERTY_DAMAGE_SUCCESS][RESPONSE] Property Damage Successfull",

  PUT_PROPERTY_DAMAGE_PENDING:
    "[PUT_PROPERTY_DAMAGE_PENDING][REQUEST] Try To update Property Damage",
  PUT_PROPERTY_DAMAGE_FAILURE:
    "[PUT_PROPERTY_DAMAGE_FAILURE][RESPONSE] Property Damage Failed",
  PUT_PROPERTY_DAMAGE_SUCCESS:
    "[PUT_PROPERTY_DAMAGE_SUCCESS][RESPONSE] Property Damage Successfull",

  PROPERTY_DAMAGE_PAGE: "PropertyDamagePage",

  GET_PROPERTY_DAMAGE_PENDING: "[REQUEST] Get Property Damage Report Data",
  GET_PROPERTY_DAMAGE_SUCCESS:
    "[RESPONSE] Get Property Damage Report Data Successfull",
  GET_PROPERTY_DAMAGE_FAILURE:
    "[RESPONSE] Get Property Damage Report Data Failed",
  CLEAR_PROPERTY_DAMAGE: "[CLEAR_PROPERTY_DAMAGE] Clear Property Damage",
  CLEAR_PROPERTY_DAMAGES: "[CLEAR_PROPERTY_DAMAGES] Clear Property Damages",
};
